import type { ShortcutDefinition } from '@sunucupark/client-core';

/**
 * The starter set: Gmail's letters where they are muscle memory, plus the
 * palette and the help dialog. Features add their own as they land; the user
 * can rebind or switch them off (ADR 0006).
 */
export const defaultShortcuts: ShortcutDefinition[] = [
  {
    id: 'app.palette',
    scope: 'global',
    keys: ['mod+k'],
    labelKey: 'shortcuts.palette',
    groupKey: 'shortcuts.groups.app',
  },
  {
    id: 'app.help',
    scope: 'global',
    keys: ['?'],
    labelKey: 'shortcuts.help',
    groupKey: 'shortcuts.groups.app',
  },
  {
    id: 'app.search',
    scope: 'global',
    keys: ['/'],
    labelKey: 'shortcuts.search',
    groupKey: 'shortcuts.groups.app',
  },
  {
    id: 'go.inbox',
    scope: 'global',
    keys: ['g i'],
    labelKey: 'shortcuts.goInbox',
    groupKey: 'shortcuts.groups.navigation',
  },
  {
    id: 'go.sent',
    scope: 'global',
    keys: ['g t'],
    labelKey: 'shortcuts.goSent',
    groupKey: 'shortcuts.groups.navigation',
  },
  {
    id: 'go.drafts',
    scope: 'global',
    keys: ['g d'],
    labelKey: 'shortcuts.goDrafts',
    groupKey: 'shortcuts.groups.navigation',
  },
  {
    id: 'mail.compose',
    scope: 'global',
    keys: ['c'],
    labelKey: 'shortcuts.compose',
    groupKey: 'shortcuts.groups.mail',
  },
  {
    id: 'list.next',
    scope: 'list',
    keys: ['j', 'ArrowDown'],
    labelKey: 'shortcuts.next',
    groupKey: 'shortcuts.groups.list',
  },
  {
    id: 'list.previous',
    scope: 'list',
    keys: ['k', 'ArrowUp'],
    labelKey: 'shortcuts.previous',
    groupKey: 'shortcuts.groups.list',
  },
  {
    id: 'list.open',
    scope: 'list',
    keys: ['Enter'],
    labelKey: 'shortcuts.open',
    groupKey: 'shortcuts.groups.list',
  },
  {
    id: 'list.select',
    scope: 'list',
    keys: ['x'],
    labelKey: 'shortcuts.select',
    groupKey: 'shortcuts.groups.list',
  },
  {
    id: 'mail.archive',
    scope: 'list',
    keys: ['e'],
    labelKey: 'shortcuts.archive',
    groupKey: 'shortcuts.groups.mail',
  },
  {
    id: 'mail.delete',
    scope: 'list',
    keys: ['#'],
    labelKey: 'shortcuts.delete',
    groupKey: 'shortcuts.groups.mail',
  },
  {
    id: 'mail.toggleRead',
    scope: 'list',
    keys: ['u'],
    labelKey: 'shortcuts.toggleRead',
    groupKey: 'shortcuts.groups.mail',
  },
  {
    id: 'reader.reply',
    scope: 'reader',
    keys: ['r'],
    labelKey: 'shortcuts.reply',
    groupKey: 'shortcuts.groups.reader',
  },
  {
    id: 'reader.replyAll',
    scope: 'reader',
    keys: ['a'],
    labelKey: 'shortcuts.replyAll',
    groupKey: 'shortcuts.groups.reader',
  },
  {
    id: 'reader.forward',
    scope: 'reader',
    keys: ['f'],
    labelKey: 'shortcuts.forward',
    groupKey: 'shortcuts.groups.reader',
  },
  {
    id: 'reader.close',
    scope: 'reader',
    keys: ['Escape'],
    labelKey: 'shortcuts.close',
    groupKey: 'shortcuts.groups.reader',
  },
  {
    id: 'compose.send',
    scope: 'compose',
    keys: ['mod+Enter'],
    labelKey: 'shortcuts.send',
    groupKey: 'shortcuts.groups.compose',
  },
  {
    id: 'compose.close',
    scope: 'compose',
    keys: ['Escape'],
    labelKey: 'shortcuts.closeCompose',
    groupKey: 'shortcuts.groups.compose',
  },
];
